import './blog.global.scss';

export { RichContentEditor, RichContentEditorModal } from 'wix-rich-content-editor';
export { RichContentViewer } from 'wix-rich-content-viewer';

export { TOOLBARS, normalizeUrl, RichContentModal } from 'wix-rich-content-common';
export { createLinkPlugin, LINK_TYPE } from 'wix-rich-content-plugin-link';
export { linkTypeMapper, LinkViewer, LinkParseStrategy } from 'wix-rich-content-plugin-link/dist/module.viewer.cjs.js';
export {
  createHashtagPlugin,
  HASHTAG_TYPE,
  Strategy as HashTagStrategy,
  Component as HashTag,
} from 'wix-rich-content-plugin-hashtag';
export { createImagePlugin, IMAGE_TYPE, ModalsMap as imageModals } from 'wix-rich-content-plugin-image';
export { imageTypeMapper } from 'wix-rich-content-plugin-image/dist/module.viewer.cjs.js';
export { createVideoPlugin, VIDEO_TYPE, ModalsMap as videoModals } from 'wix-rich-content-plugin-video';
export { videoTypeMapper } from 'wix-rich-content-plugin-video/dist/module.viewer.cjs.js';
export { createGalleryPlugin, GALLERY_TYPE, ModalsMap as galleryModals } from 'wix-rich-content-plugin-gallery';
export { galleryTypeMapper } from 'wix-rich-content-plugin-gallery/dist/module.viewer.cjs.js';
export { createDividerPlugin, DIVIDER_TYPE } from 'wix-rich-content-plugin-divider';
export { dividerTypeMapper } from 'wix-rich-content-plugin-divider/dist/module.viewer.cjs.js';
export { createHtmlPlugin, HTML_TYPE } from 'wix-rich-content-plugin-html';
export { htmlTypeMapper } from 'wix-rich-content-plugin-html/dist/module.viewer.cjs.js';
export {
  createTextColorPlugin,
  createTextColorDecorator,
  TEXT_COLOR_TYPE,
  ModalsMap as textColorModals,
} from 'wix-rich-content-plugin-text-color';
export { createHeadersMarkdownDecorator, HEADERS_MARKDOWN_TYPE } from 'wix-rich-content-plugin-headers-markdown';

export const RCE_VERSION = '3.3.3';
